import { EventEmitter } from 'events';
import { TypeKeys } from './actionsUtils';
import type { CommonError } from '../../common/types/errors';
import type { DialogParams } from '../../common/types/dialog';
import type { SubscriptionAction } from '../../generated/api/subscriptionAction';

// Side effect events from non-auth epics (or other places outside auth context) to auth context

/**
 * @deprecated This is intended to be used during redux removal transition. Do not use anywhere else
 */
const authEventBus = new EventEmitter();

type AuthEventActionType =
  | 'LOGIN'
  | 'VALIDATE'
  | 'LOGOUT'
  | 'SET_ACTIVE_ACCOUNT'
  | 'UPDATE_AUTH_RESULT'
  | 'FILTER_EXPIRING_EPP_SUBS'
  | 'RESET_ERRORS';

export const dispatchAuthAction = (action: AuthEventActionType, ...args: unknown[]) =>
  authEventBus.emit(action, ...args);

export const subscribeAuthAction = (action: AuthEventActionType, handler: (...args: unknown[]) => void) =>
  authEventBus.on(action, handler);

export const unsubscribeAuthAction = (action: AuthEventActionType, handler: (...args: unknown[]) => void) =>
  authEventBus.off(action, handler);

// Action to clear state in various non-auth reducers (e.g., on logout)
export interface ClearStateAction {
  type: TypeKeys.CLEAR_STATE;
}

export const clearState = (): ClearStateAction => ({
  type: TypeKeys.CLEAR_STATE,
});

export interface ClearEmployeeSubsAction {
  type: TypeKeys.CLEAR_EMPLOYEE_SUBS;
}

export const clearEmployeeSubs = (): ClearEmployeeSubsAction => ({
  type: TypeKeys.CLEAR_EMPLOYEE_SUBS,
});

export interface ShowAuthFailedDialogAction {
  type: TypeKeys.SHOW_AUTH_FAILED_DIALOG;
  params?: DialogParams;
  error?: string;
}

export const showAuthFailedDialog = (params?: DialogParams, error?: string): ShowAuthFailedDialogAction => ({
  type: TypeKeys.SHOW_AUTH_FAILED_DIALOG,
  params,
  error,
});

export interface UpdatePendingSubscriptionActionsAction {
  type: TypeKeys.UPDATE_PENDING_SUBSCRIPTION_ACTIONS;
  pendingSubscriptionActions?: SubscriptionAction[];
}

export const updatePendingSubscriptionActions = (
  pendingSubscriptionActions?: SubscriptionAction[]
): UpdatePendingSubscriptionActionsAction => ({
  type: TypeKeys.UPDATE_PENDING_SUBSCRIPTION_ACTIONS,
  pendingSubscriptionActions,
});

export interface LoadAuxiliaryEsimSubscriptionAction {
  type: TypeKeys.LOAD_AUXILIARY_ESIM_SUBSCRIPTION;
}

export const loadAuxiliaryEsimSubscription = (): LoadAuxiliaryEsimSubscriptionAction => ({
  type: TypeKeys.LOAD_AUXILIARY_ESIM_SUBSCRIPTION,
});

export interface SetDialogSubmittingAction {
  type: TypeKeys.SET_DIALOG_SUBMITTING;
}

export const setDialogSubmitting = (): SetDialogSubmittingAction => ({
  type: TypeKeys.SET_DIALOG_SUBMITTING,
});

export interface MoveCheckoutToNextStepAction {
  type: TypeKeys.MOVE_CHECKOUT_TO_NEXT_STEP;
  errors?: CommonError[];
}

export const moveCheckoutToNextStep = (errors?: CommonError[]): MoveCheckoutToNextStepAction => ({
  type: TypeKeys.MOVE_CHECKOUT_TO_NEXT_STEP,
  errors,
});

export type AuthSideEffectActionTypes =
  | ClearStateAction
  | ClearEmployeeSubsAction
  | ShowAuthFailedDialogAction
  | UpdatePendingSubscriptionActionsAction
  | LoadAuxiliaryEsimSubscriptionAction
  | SetDialogSubmittingAction
  | MoveCheckoutToNextStepAction;
